/* NOTE: increment `formatVersion` when you create breaking changes in local storage format/values
 * versions must start from 1, version 0 is invalid
 */
const formatVersion = 1;

const getItem = (key: string, defaultValue: any) => {
    try {
        const item = window.localStorage.getItem(key);

        return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
        console.error(error);
        return defaultValue;
    }
};

const setItem = (key: string, value: any) => {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.error(error);
    }
};

const clear = () => {
    try {
        window.localStorage.clear();
    } catch (error) {
        console.error(error);
    }
};

const removeItem = (key: string) => {
    try {
        window.localStorage.removeItem(key);
    } catch (error) {
        console.error(error);
    }
};

const validate = (callback: () => void) => {
    const version = getItem('localstorage/formatversion', 0);

    if (!version || version < formatVersion) {
        clear();
        setItem('localstorage/formatversion', formatVersion);
    }

    callback();
};

const LocalStorage = {
    getItem,
    setItem,
    clear,
    removeItem,
    formatVersion,
    validate
};

export default LocalStorage;
